var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"allowfullscreen":"","src":(_vm.widgetUrl + "/?" + _vm.widgetQuery),"allow":"camera;microphone","id":"botter-iframe"}})}
var staticRenderFns = []

export { render, staticRenderFns }